import { render, staticRenderFns } from "./hzyc.vue?vue&type=template&id=0fa687c8&scoped=true"
import script from "./hzyc.vue?vue&type=script&lang=js"
export * from "./hzyc.vue?vue&type=script&lang=js"
import style0 from "./hzyc.vue?vue&type=style&index=0&id=0fa687c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa687c8",
  null
  
)

export default component.exports